/* tslint:disable */
import styled from '@emotion/styled';
import { Link } from 'gatsby';
import React from 'react';

import withTracking from '../../components/Common/withTracking';
import { theme } from '@kindur/components';

import { BasicLinkButton } from '../../elements/LinkButton';

import { injectGlobal } from 'react-emotion';

injectGlobal`
  h2 {
    font-family: 'DM Sans', sans-serif;
    font-size: 1.5rem;
    letter-spacing: 0;
    line-height: 100%;
  }
`

const Container = styled('footer')`
  color: ${theme.colors.Teal100};
  font-family: 'DM Sans', sans-serif;
  letter-spacing: 0;
  padding: 0;
`;

const ContactContainer = styled('div')`
  margin: 4em 0;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  ${theme.breakpoints.smallTabletDown} {
    flex-flow: column nowrap;
  }
`;
const ContactUs = styled('div')``;
const FooterLinks = styled('ul')`
  list-style: none;
  margin-left: auto;
  margin-right: 3em;
  ${theme.breakpoints.smallTabletDown} {
    margin-right: 10em;
  }
  li {
    font-size: 1.4em;
    line-height: 2em;
    ${theme.breakpoints.smallTabletDown} {
      font-size: ${theme.fontSizes.medium};
    }
    a {
      color: ${theme.colors.Teal100};
      text-decoration: none;
    }
  }
`;
const CurrentOpeningsLink = styled(BasicLinkButton)`
  padding: 0;
`;

const TrackComponentName = 'Footer';

// @ts-ignore
const Footer = ({ children, showContactContainer = true, showContactUsFooter = true, track }) => (
  <Container>
    {showContactContainer && <ContactContainer>
      {showContactUsFooter && (
        <ContactUs>
          <h2>Contact us today.</h2>
          <p>We&apos;re here to help get you started.</p>
          <p>
            Call us{' '}
            <a href={'tel:8009613572'} onClick={() => track(`PhoneNum`, TrackComponentName)} title={"Kindur's phone number"}>
              (800) 961-3572
            </a>
            .
          </p>
        </ContactUs>
      )}
      <FooterLinks>
        <li>
          <Link to={'/about/'} onClick={() => track(`AboutUs`, TrackComponentName)} title={'About Kindur'}>
            About
          </Link>
        </li>
        <li>
          <Link to={'/privacy/'} onClick={() => track(`Privacy`, TrackComponentName)} title={"Kindur's Privacy Policy"}>
            Privacy Policy
          </Link>
        </li>
        <li>
          <CurrentOpeningsLink
            href={'https://apply.workable.com/kindur/'}
            title={'Current Openings at Kindur'}
            target={'_blank'}
            onClick={() => track(`Careers`, TrackComponentName)}
          >
            Careers
          </CurrentOpeningsLink>
        </li>
        {showContactUsFooter && (
          <li>
            <Link to={'/contact/'} onClick={() => track(`ContactUs`, TrackComponentName)} title={'Contact Us'}>
              Contact
            </Link>
          </li>
        )}
      </FooterLinks>
    </ContactContainer>}
    {children}
  </Container>
);

Footer.displayName = TrackComponentName;

export default withTracking(Footer);
